import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as pathUtils from "../../../utils/pathUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_UNIVERSAL } from "./abstract/universalAbstract";

const _action = `${ACTION_PREFIX_UNIVERSAL}_update_comment`;
const _header = `Update node comment`;

export const nodeUpdateComment = (root, id, comment) => {
  const _payload = nodeUpdateCommentLogic(root, id, comment);

  logger.logAction(_action, _payload, ACTION_PREFIX_UNIVERSAL);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const nodeUpdateCommentLogic = (root, id, comment) => {
  const { data: _node, index: _index } = getNodeById(root, id);
  const { data: _nodeParent } = getNodeById(root, pathUtils.getIdParent(id));

  const _nodeBackup = systemUtils.createDeepCopy(_node);

  nodeUtils.setComment(_node, comment);

  return generatePayload(_nodeBackup, _index, _nodeParent, nodeUtils.getComment(_node));
};

//--------------------------------------------------------------------------------

const generatePayload = (node, index, nodeParent, commentAfter) => {
  return {
    group: ActionGroupTypes.UPDATE,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: `Update node comment '${nodeUtils.getName(node)}'.`,
    node: node,
    uuid: nodeUtils.getUUID(node),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
    commentBefore: nodeUtils.getComment(node) ?? "",
    commentAfter: commentAfter,
  };
};
